import PropTypes from 'prop-types';
import React from 'react';

import { PlusIcon } from 'lucide-react';
import { Button, Row, Col, cn } from 'twyne-new.ui';

import { SortableField, SortableFieldsContainer, DragHandle } from 'components/Sortable';
import Rules from 'components/rules/Rules';

import Collapsible from '../fields/Collapsible';
import { extraRuleFields } from '../fieldsUtil';

export function InnerCardRules({ type, rules, onChange, header, title, children, isCollapsed, chevClassName, draggable = false, onConflict }) {
  rules = rules || { condition: 'and', groups: [] }

  const headerButtons = <div className='flex gap-2 py-2 items-center'>
    {draggable ? <DragHandle className='px-1' /> : null}
    {header}
  </div>

  return <div className='mb-2'>
    <Collapsible header={headerButtons} openOnChevronClick contentClass='p-4'>
      <Row>
        <Col size='12'>
          {children}
        </Col>
        <Col size='12'>
          {type && <Rules
            rules={rules}
            handleChange={state => onChange(state)}
            extraFields={extraRuleFields}
            origin='form-populate'
            onConflict={onConflict}
          />}
        </Col>
      </Row>
    </Collapsible>
  </div>
}

export class ActionsContainer extends React.Component {
  handleChangeCards = change => {
    const { data, onChange } = this.props
    change(data)
    onChange(data)
  }

  handleAddCard = () => {
    this.handleChangeCards(data => {
      data.push({ type: null })
    })
  }

  handleChangeCard = idx => itemChange => {
    this.handleChangeCards(data => {
      let [card] = data.splice(idx, 1)
      if (itemChange) {
        card = { ...card, ...itemChange }
        data.splice(idx, 0, card)
      }
    })
  }

  handleSortColumn = ({ oldIndex, newIndex = null }) => {
    this.handleChangeCards(data => {
      const deleted = data.splice(oldIndex, 1)
      newIndex !== null && data.splice(newIndex, 0, ...deleted)
    })
  }

  render() {
    const { data, Component, title, className = '' } = this.props
    return <>
      <div className='flex justify-between items-center mb-2'>
        <span className='text-md twy-text-base-accent'>{title}</span>
        <Button size='sm' color='accent' onClick={this.handleAddCard}>
          <PlusIcon size={16} />
          Add
        </Button>
      </div>
      <div className={cn('max-h-[40vh] overflow-y-auto pr-2 -mr-2', className)}>
        <SortableFieldsContainer axis="y" lockAxis="y" onSortEnd={this.handleSortColumn} useDragHandle={true} hideSortableGhost={true}>
          {data && data.map((cardData, idx) => <SortableField key={`item-${idx}`} index={idx} customDrag={true}>
            <Component onConflict={this.props.onConflict} {...cardData} key={idx} index={idx} onChange={this.handleChangeCard(idx)} />
          </SortableField>)}
        </SortableFieldsContainer>
      </div>
    </>
  }
}

ActionsContainer.propTypes = {
  Component: PropTypes.any,
  data: PropTypes.array,
  onChange: PropTypes.func,
}
